import { createReducer } from "../../../../reducers/reducerUtil";
import {

  CREATE_COMPLAINT,
  UPDATE_COMPLAINT,
  DELETE_COMPLAINT
} from "./complaintConstants";

const initialState = [{}];

const createComplaint = (state, payload) => {
  return [...state, payload.complaint];
};

const updateComplaint = (state, payload) => {
  return [
    ...state.filter(complaint => complaint.id !== payload.complaint.id),
    payload.complaint
  ];
};

const deleteComplaint = (state, payload) => {
  return [...state.filter(complaint => complaint.id !== payload.complaintId)];
};

export default createReducer(initialState, {
  [CREATE_COMPLAINT]: createComplaint,
  [UPDATE_COMPLAINT]: updateComplaint,
  [DELETE_COMPLAINT]: deleteComplaint
});
